import React, { ReactNode, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { useDispatch } from 'react-redux'
import { updateDarkMode } from './routerSlice'
import { useReturnCurrentUser } from '../user/userSlice'

interface IProps {
    children: React.ReactNode;
  }
  
// const DarkModeWrapper: React.FC<IProps> = ({ children, ...props }) => {
    
//     const disptach = useDispatch()
//     const { darkMode } = useSelector((state: RootState) => state.router)
//     const [darkModeLocalStorage, setDarkModeLocalStorage] = useState<boolean>(false)
//     // const [isLocalStorageSet, seIs]

//     const getLocalStorageDarkMode = window.localStorage.getItem("dark-mode")

//     useEffect(() => {
//         if (getLocalStorageDarkMode == "enabled"){
//             setDarkModeLocalStorage(true)
//         }else{
//             setDarkModeLocalStorage(false)
//         }
//     }, [getLocalStorageDarkMode])

//     useEffect(() => {
//         if (darkModeLocalStorage){
//             disptach(updateDarkMode(true))
//             window.localStorage.setItem("dark-mode", "enabled")
//         }else{
//             disptach(updateDarkMode(false))
//             window.localStorage.setItem("dark-mode", "disabled")
//         }
//     }, [darkModeLocalStorage])

//     if (darkMode){
//         return(
//             <div className="darkmode-wrapper">
//                 {children}
//             </div>
//         )
//     }

//     return <>{children}</>
// }

const DarkModeWrapper: React.FC<IProps> = ({ children, ...props }) => {
    
    const disptach = useDispatch()
    const { darkMode } = useSelector((state: RootState) => state.router)

    const currentUser = useReturnCurrentUser()

    useEffect(() => {
        if (currentUser && currentUser.theme){
            disptach(updateDarkMode(currentUser.theme === "dark" ? true : false))

            const bodyElem = document.getElementById("site-body")

            if (bodyElem){
                if (currentUser.theme === "dark"){
                    bodyElem.classList.add("dark-mode")
                }else{
                    bodyElem.classList.remove("dark-mode")
                }
            }

        }   
    }, [currentUser])

    return(
        <div className={darkMode ? "darkmode-wrapper" : ""}>
            {children}
        </div>
    )
}


export default DarkModeWrapper